import { render, staticRenderFns } from "./account-agent.vue?vue&type=template&id=e32ada20&scoped=true"
import script from "./account-agent.vue?vue&type=script&lang=js"
export * from "./account-agent.vue?vue&type=script&lang=js"
import style0 from "./account-agent.vue?vue&type=style&index=0&id=e32ada20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32ada20",
  null
  
)

export default component.exports